import React, { useState } from 'react';
import { translate } from '../../services/translate';
import MyDropDownPicker from '../../components/MyDropDownPicker';
import BasicModal from '../../components/BasicModal';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: (serverPoolId: string) => (void | Promise<void>);
    availableServerPools: { id: string; }[];
}

export default function PurgeCamerasModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    availableServerPools,
}: ModalProps) {

    const [serverPoolDropdownOpen, setServerPoolDropdownOpen] = useState(false);
    const [serverPoolId, setServerPoolId] = useState<string | null>(null);

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('selectServerPoolToPurgeCameras')}
            width='small'
            mobileHeight='fill'
            primaryButton={{
                text: translate('confirm'),
                onClick: async () => {
                    if (!serverPoolId) {
                        return;
                    }
                    await onSubmit(serverPoolId);
                },
                disabled: !serverPoolId,
            }}
            disableScrollView={true}
        >
            <MyDropDownPicker
                placeholder={translate('serverPools')}
                searchable={true}
                items={[{}, ...availableServerPools.map(sp => ({
                    value: sp.id,
                    label: sp.id,
                }))]}
                open={serverPoolDropdownOpen}
                setOpen={setServerPoolDropdownOpen}
                setValue={setServerPoolId}
                value={serverPoolId}
                zIndex={3}
            />
        </BasicModal>
    );
}
